<template>
  <div id="app">
    <router-view />
    <GlobalFooter />
  </div>
</template>

<script>
import GlobalFooter from "@/components/GlobalFooter";
export default {
  components: {
    GlobalFooter,
  },
  metaInfo: {
    title: "반응형 브랜딩과 감영길예술가의 거리",
  },
};
</script>

<style lang="scss"></style>
